import { render, staticRenderFns } from "./AdServerPromotionPlacement.vue?vue&type=template&id=4dbfc3a1"
import script from "./AdServerPromotionPlacement.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdServerPromotionPlacement.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports